import Link from 'components/elements/Link'
import Icon from 'components/elements/Icon'

import styles from './paginator.module.scss'

type Props = {
  activePage: number
  totalPages: number
  urlBeforePageNumber: string // Gets concated with the page number on the end as a link eg: 'https://url.com/page=' + 4
  className?: string
}

const Paginator = ({ className = '', activePage, totalPages, urlBeforePageNumber }: Props) => {
  const getUrl = (page: number) => {
    if (page <= 1) return urlBeforePageNumber + 1
    if (page >= totalPages) return urlBeforePageNumber + totalPages

    return urlBeforePageNumber + page
  }

  return (
    <div className={`${styles.container} ${className}`}>
      <Link href={getUrl(activePage - 1)} className={activePage === 1 ? styles.disabled : undefined}>
        <Icon name="chevron left" />
      </Link>

      {activePage !== 1 && <Link href={getUrl(1)}>1</Link>}

      {activePage > 3 && <span>...</span>}

      {activePage - 2 > 1 && activePage === totalPages && <Link href={getUrl(activePage - 2)}>{activePage - 2}</Link>}

      {activePage - 1 > 1 && <Link href={getUrl(activePage - 1)}>{activePage - 1}</Link>}

      <Link href={getUrl(activePage)} className={styles.selected}>
        {activePage}
      </Link>

      {activePage + 1 < totalPages && <Link href={getUrl(activePage + 1)}>{activePage + 1}</Link>}

      {activePage + 2 < totalPages && activePage === 1 && <Link href={getUrl(activePage + 2)}>{activePage + 2}</Link>}

      {activePage < totalPages - 2 && <span>...</span>}

      {activePage !== totalPages && totalPages > 0 && <Link href={getUrl(totalPages)}>{totalPages}</Link>}

      <Link
        href={getUrl(activePage + 1)}
        className={activePage === totalPages || totalPages < 1 ? styles.disabled : undefined}>
        <Icon name="chevron right" />
      </Link>
    </div>
  )
}

export default Paginator

type ButtonProps = {
  onPageChange: (page: number) => void
  activePage: number
  totalPages: number
  className?: string
}

export const ButtonPaginator = ({ className = '', activePage, totalPages, onPageChange }: ButtonProps) => {
  return (
    <div className={`${styles.container} ${className}`}>
      <button onClick={() => onPageChange(activePage - 1)} className={activePage === 1 ? styles.disabled : undefined}>
        <Icon name="chevron left" />
      </button>

      {activePage !== 1 && <button onClick={() => onPageChange(1)}>1</button>}

      {activePage > 3 && <span>...</span>}

      {activePage - 2 > 1 && activePage === totalPages && (
        <button onClick={() => onPageChange(activePage - 2)}>{activePage - 2}</button>
      )}

      {activePage - 1 > 1 && <button onClick={() => onPageChange(activePage - 1)}>{activePage - 1}</button>}

      <button onClick={() => onPageChange(activePage)} className={styles.selected}>
        {activePage}
      </button>

      {activePage + 1 < totalPages && <button onClick={() => onPageChange(activePage + 1)}>{activePage + 1}</button>}

      {activePage + 2 < totalPages && activePage === 1 && (
        <button onClick={() => onPageChange(activePage + 2)}>{activePage + 2}</button>
      )}

      {activePage < totalPages - 2 && <span>...</span>}

      {activePage !== totalPages && totalPages > 0 && (
        <button onClick={() => onPageChange(totalPages)}>{totalPages}</button>
      )}

      <button
        onClick={() => onPageChange(activePage + 1)}
        className={activePage === totalPages || totalPages < 1 ? styles.disabled : undefined}>
        <Icon name="chevron right" />
      </button>
    </div>
  )
}
